<div class="center"> 
    <div class=" siser-logo"></div>
</div>
<hr class="shine">
<h1 class="retroshadow">¡Bienvenido, {{user.nombre}} {{user.apellido}}!</h1>